import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useIntl } from 'react-intl';

import { formatMoney } from '../../../util/currency';
import { FormattedMessage } from '../../../util/reactIntl';
import { LINE_ITEM_ANNUAL_PASS_VOUCHER, LINE_ITEM_VOUCHER } from '../../../util/types';
import { itemValueStyles, lineItemStyles } from './BookingBreakdown.styles';

/**
 * Renders the manual voucher row and the annual pass voucher row.
 *
 * An annual pass voucher that covers the whole stay is already zeroed by
 * adjustLineItemsForDisplay, which makes its line total non-negative and so
 * hides its row.
 *
 * @param {Object} props
 * @param {Array} props.lineItems line items to display, see adjustLineItemsForDisplay
 * @param {boolean} props.isCustomer whether the breakdown is rendered for the customer
 */
const LineItemVoucherMaybe = ({ lineItems, isCustomer }) => {
  const intl = useIntl();

  if (!isCustomer) return null;

  const voucherLineItem = lineItems.find(
    (item) => item.code === LINE_ITEM_VOUCHER && !item.reversal,
  );

  const annualPassVoucherLineItem = lineItems.find(
    (item) => item.code === LINE_ITEM_ANNUAL_PASS_VOUCHER && !item.reversal,
  );

  const voucherTotal = voucherLineItem?.lineTotal;
  const formattedTotal = voucherTotal ? formatMoney(intl, voucherTotal) : null;

  const annualPassVoucherTotal = annualPassVoucherLineItem?.lineTotal;
  const annualPassFormattedTotal = annualPassVoucherTotal
    ? formatMoney(intl, annualPassVoucherTotal)
    : null;

  return (
    <>
      {formattedTotal ? (
        <Box sx={lineItemStyles}>
          <Typography sx={{ flex: 1 }} variant="lineItemLabel">
            <FormattedMessage id="BookingBreakdown.voucher" />
          </Typography>
          <Typography sx={itemValueStyles} variant="lineItemLabel">{formattedTotal}</Typography>
        </Box>
      ) : null}
      {annualPassFormattedTotal && annualPassVoucherTotal.amount < 0 ? (
        <Box sx={lineItemStyles}>
          <Typography sx={{ flex: 1 }} variant="lineItemLabel">
            <FormattedMessage id="BookingBreakdown.annualPassVoucher" />
          </Typography>
          <Typography sx={itemValueStyles} variant="lineItemLabel">{annualPassFormattedTotal}</Typography>
        </Box>
      ) : null}
    </>
  );
};

export default LineItemVoucherMaybe;
